import { Button } from "@/components/ui/Button";

interface DeleteConfirmDialogProps {
	rosterName: string;
	onConfirm: () => void;
	onCancel: () => void;
}

export function DeleteConfirmDialog({ rosterName, onConfirm, onCancel }: DeleteConfirmDialogProps) {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center">
			{/* Backdrop */}
			<div
				className="absolute inset-0 bg-black/60"
				onClick={onCancel}
				onKeyDown={(e) => {
					if (e.key === "Escape") onCancel();
				}}
			/>

			{/* Dialog */}
			<div className="relative bg-bg-secondary border border-border-default rounded-lg shadow-lg p-6 w-full max-w-md mx-4">
				<h2 className="text-lg font-bold text-text-primary mb-2">Delete Roster</h2>
				<p className="text-sm text-text-secondary mb-6">
					Are you sure you want to delete{" "}
					<span className="font-semibold text-text-primary">{rosterName}</span>? This action
					cannot be undone.
				</p>
				<div className="flex justify-end gap-3">
					<Button variant="secondary" size="md" onClick={onCancel}>
						Cancel
					</Button>
					<Button variant="danger" size="md" onClick={onConfirm}>
						Delete
					</Button>
				</div>
			</div>
		</div>
	);
}
